import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { Analytics } from 'src/domains/casino/webview/bonus-engine/analytics/Analytics';
import { BonusCreator } from 'src/domains/casino/webview/bonus-engine/bonus-creator/BonusCreator';
import { BonusCreation } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/BonusCreation';
import { Calendar } from 'src/domains/casino/webview/bonus-engine/calendar/Calendar';
import { CampaignList } from 'src/domains/casino/webview/bonus-engine/campaign-list/CampaignList';
import { Campaign } from 'src/domains/casino/webview/bonus-engine/campaign/Campaign';
import { observer } from 'src/utils/mobx-react';

export const BonusEngineContent = observer('BonusPageContent', (): React.ReactElement => {
    const { routerBackoffice } = useAppStateContext();
    const { bonusTabParam } = routerBackoffice;

    return (
        <>
            {bonusTabParam === 'campaign-list' && <CampaignList />}
            {bonusTabParam === 'calendar' && <Calendar />}
            {bonusTabParam === 'analytics' && <Analytics />}
            {bonusTabParam === 'bonus-creator' && <BonusCreator />}
            {(bonusTabParam === 'new-campaign' || bonusTabParam === 'edit-campaign') && <Campaign />}
            {(bonusTabParam === 'new-bonus-creation' || bonusTabParam === 'edit-bonus-creation') && <BonusCreation />}
        </>
    );
});
